import {replace} from 'react-router-redux'
import {setUIState} from '../core/redux/ui'
import {loadActiveCampaign} from '../satisfaction/actions'
import {DEFAULT_TICKET_QUERY, loadTicketStream, loadTicket, createTicket, enterTicket} from './actions'
import TicketLayout from './components/TicketLayout'
import TicketStreamLayout from './components/TicketStreamLayout'
import TicketDashboardLayout from './components/TicketDashboardLayout'
import TicketDetail from './components/TicketDetail'
import ShowDocumentsPage from './components/ShowDocumentsPage'

function enterOpenTicket(dispatch) {
    dispatch(setUIState('Ticket/OpenTicketModal', {opened: true}))
    return dispatch(replace('/tickets'))
}

export function openTicketRoute(rootPath, dispatcher) {
    return {
        path: rootPath,
        indexRoute: {
            onEnter: dispatcher(enterOpenTicket)
        }
    }
}

export default function(rootPath, dispatcher, {getState}) {

    function enterTicketStream(dispatch) {
        const state = getState()
        const {criteria} = state.ticket
        const {authenticated} = state.user

        return Promise.all([
            dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, ...criteria})),
            // dashboard
            authenticated.company && dispatch(loadActiveCampaign(authenticated.company.uid)),
        ])
    }

    return {
        path: rootPath,
        component: TicketLayout,
        onEnter: dispatcher(enterTicketStream),
        indexRoute: {
            component: TicketStreamLayout
        },
        childRoutes: [
            {
                path: 'dashboard',
                component: TicketDashboardLayout
            },
            {
                path: 'new',
                component: TicketDetail,
                onEnter: dispatcher((d) => d(createTicket()))
            },
            {
                path: ':id',
                component: TicketDetail,
                onEnter: dispatcher(enterTicket)
            },
            {
                path: ':id/documents',
                component: ShowDocumentsPage,
                onEnter: dispatcher(enterTicket)
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./lib/ticket/routes.js